export default __webpack_public_path__ + "static/FreeSync-Premium-Pro-e778933d70e887e4250a622a17fc8b7f.webp";